import { render, staticRenderFns } from "./PageProducts.vue?vue&type=template&id=14605882&"
import script from "./PageProducts.vue?vue&type=script&lang=js&"
export * from "./PageProducts.vue?vue&type=script&lang=js&"
import style0 from "./PageProducts.vue?vue&type=style&index=0&id=14605882&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports